import api from './Api';

export interface UserPrintSettings {
  id?: number;
  templateName?: string;
  
  // Label dimensions
  labelWidth: number;
  labelHeight: number;
  labelGap: number;
  labelPadding: number;
  rotate: boolean;
  
  // Page settings
  pageSize: string;
  pageMarginTop: number;
  pageMarginRight: number;
  pageMarginBottom: number;
  pageMarginLeft: number;
  
  // Display settings
  showBarcode: boolean;
  showQr: boolean;
  currency: string;
  
  // Table mode
  tableColumns: number;
  tableCellWidth: number;
  tableCellHeight: number;
  tableCellGap: number;
  containerPadding: number;
  cellPadding: number;
  
  // Label sections
  labelSectionsJson: string; // JSON string
}

export const UserPrintSettingsApi = {
  /**
   * Get current user's print settings (global, not company-specific)
   */
  get: () => 
    api.get<UserPrintSettings>(`/user-print-settings`),
  
  /**
   * Save or update current user's print settings (global, not company-specific)
   */
  save: (settings: UserPrintSettings) => 
    api.post<UserPrintSettings>(`/user-print-settings`, settings),
  
  /**
   * Get current user's print settings for a specific company (deprecated - now returns user settings)
   */
  getForCompany: (companyId: number) => 
    api.get<UserPrintSettings>(`/user-print-settings/company/${companyId}`),
  
  /**
   * Save or update current user's print settings for a company (deprecated - now saves user settings)
   */
  saveForCompany: (companyId: number, settings: UserPrintSettings) => 
    api.post<UserPrintSettings>(`/user-print-settings/company/${companyId}`, settings),
  
  /**
   * Delete user's print settings
   */
  delete: (id: number) => 
    api.delete(`/user-print-settings/${id}`),
};
